<script>
export default {
  name: 'TimeTrackingNoTrackingPane',
};
</script>

<template>
  <div class="time-tracking-no-tracking-pane">
    <span class="no-value">
      {{ __('No estimate or time spent') }}
    </span>
  </div>
</template>
